import { globals } from "../globals"
import { nameToUrlFormatted } from "../routes/routes.functions"
import { battleModeColors } from "../theme"

export const formatPercentaje = (num: number | null) => num !== null ? (num * 100).toFixed(2) : "?"

export const formatScore = (num: number | null) => num !== null ? (num * 20).toFixed(2) : "?"

export const formatNameToTitleCase = (name: string) =>
    name.toLowerCase().replace(/(^|[\s.,;:!?()])([a-z])/g, (_, sep, char) => sep + char.toUpperCase())

export enum ImageType {
    BODY = "body",
    AVATAR = "avatar",
    STAR_POWER = "starpower",
    GADGETS = "gadget"
}

export const getBrawlerImgSrc = (type: ImageType, brawlerName?: string, name?: string): string => {
    const brawler = brawlerName ? nameToUrlFormatted(brawlerName) : "unknown";
    const asset = type === ImageType.BODY || type === ImageType.AVATAR || !brawlerName || !name ? "" : "-" + nameToUrlFormatted(name);
    return getImageSrc(`/images/brawlers/${brawler}/${type}${asset}.webp`)
}

export const getGearSrc = (name?: string): string => {
    const asset = name ? nameToUrlFormatted(name) : "unknown";
    return getImageSrc(`/images/gears/${asset}.webp`)
}

export const getImageSrc = (route: string): string => {
    return `${route}?cb=${globals.cacheBoostingImages}`
}

export const getModeColor = (mode: string) => {
    let modeColor = mode.replace("_5V5", "")
    if (modeColor.includes("SHOWDOWN")) {
        modeColor = "SHOWDOWN"
    }
    return battleModeColors[modeColor as keyof typeof battleModeColors] || battleModeColors.UNTRACKED
}
